import ReactGA from "react-ga4";

export function initializeAnalytics() {
  ReactGA.initialize("G-XXXXXXXXXX"); // Replace with your actual GA4 measurement ID
}
